<template>
  <div id="pers-topic" name="hrms32e-topic">
    <div class="main-topic-box">
      <i class="left-arrow fa fa-angle-left" aria-hidden="true" @click.stop="onArrowLeft()"></i>
      <div class="main-topic" @click="toggleMenuMobile()">{{ nameTopic(page) }}</div>
      <i class="right-arrow fa fa-angle-right" aria-hidden="true" @click.stop="onArrowRight()"></i>
    </div>
	  <div class="main-topic-box-lv2" v-show="page === 2">
      <i class="left-arrow fa fa-angle-left" aria-hidden="true" @click.stop="onArrowSubLeft()"></i>
      <div class="main-topic-lv2">{{ nameSubTopic(subPage) }}</div>
      <i class="right-arrow fa fa-angle-right" aria-hidden="true" @click.stop="onArrowSubRight()"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hrms32e-topic',
  methods: {
    nameTopic (page) {
      switch (parseInt(page)) {
        case 1:
          return this.labels['HRMS32EC1']['100']
        case 2:
          return this.labels['HRMS32EC1']['110']
        case 3:
          return this.labels['HRMS32EC1']['120']
        case 4:
          return this.labels['HRMS32EC1']['130']
        case 5:
          return this.labels['HRMS32EC1']['140']
        case 6:
          return this.labels['HRMS32EC1']['150']
      }
    },
    nameSubTopic (subPage) {
      switch (parseInt(subPage)) {
        case 1:
          return this.labels['HRMS32EC3']['10']
        case 2:
          return this.labels['HRMS32EC4']['10']
        case 3:
          return this.labels['HRMS32EC5']['10']
        case 4:
          return this.labels['HRMS32EC6']['10']
        case 5:
          return this.labels['HRMS32EC7']['10']
        case 6:
          return this.labels['HRMS32EC8']['10']
        case 7:
          return this.labels['HRMS32EC15']['10']
      }
    }
  },
  props: [ 'nowLang', 'labels', 'detail', 'pcDisp', 'page', 'subPage', 'toggleMenuMobile', 'onArrowLeft', 'onArrowRight', 'onArrowSubLeft', 'onArrowSubRight' ]
}
</script>


// WEBPACK FOOTER //
// topic.vue?0965a416